import { render, staticRenderFns } from "./add-edit-advertiser.vue?vue&type=template&id=4ad23146&scoped=true"
import script from "./add-edit-advertiser.vue?vue&type=script&lang=js"
export * from "./add-edit-advertiser.vue?vue&type=script&lang=js"
import style0 from "./add-edit-advertiser.vue?vue&type=style&index=0&id=4ad23146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad23146",
  null
  
)

export default component.exports